import actions from './actions';
import mutations from './mutations';
import state from './initialState';
import getters from './getters';

const campaigns = {
  namespaced: true,

  state,

  getters,

  mutations,

  actions,
};

export default campaigns;
